import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import { RendimentoMensalComercial } from './RendimentoMensalComercial';

function RendimentoMensalComercialPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Rendimento Mensal Comercial'));
  return (
    <RendimentoMensalComercial />
  );
}

export default withTokenInterceptor(RendimentoMensalComercialPage);
